import React from "react";
import Tooltip from "../Tooltip";
import styles from "./SliderLabel.module.scss";

const SliderLabel = ({
  label,
  tooltipId,
  tooltipContent,
  value,
  isFastFlow = false,
  className = "",
  showTooltip = true,
  children,
}) => {
  return (
    <div
      className={`${styles.contentname} ${
        isFastFlow ? styles.fastContentName : ""
      } ${className}`}
    >
      <div className={styles.sliderData}>
        <div className={styles.labelContainer}>
          {label}
          {showTooltip && tooltipId && tooltipContent && (
            <Tooltip
              delay={100}
              place="top"
              id={tooltipId}
              light
              content={tooltipContent}
              style={{ marginLeft: '4px', marginBottom: '3px', verticalAlign: 'middle' }}
            />
          )}
        </div>
        <div className={styles.value}>{value}</div>
      </div>
      {children}
    </div>
  );
};

export default SliderLabel;
